import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  useAuth,
  useSocket,
  initSocketManager,
  setSocketToken,
} from '@bb/session-manager';

import { Button } from '@mui/material';
import { BBDialog } from './components';
import { QuotaExceededModal } from './components/subscription';

const GlobalEventManager = ({ children = null }) => {
  const { auth } = useAuth();

  const [showBackdrop, setShowBackdrop] = useState(false);
  const handleOpen = () => {
    setShowBackdrop(true);
  };

  const accessToken = auth?.user?.access_token;

  // Ensure socket manager is initialized with current token
  // (also handled by session hooks, but this guards early-mount timing)
  useEffect(() => {
    if (accessToken) {
      initSocketManager();
      setSocketToken(accessToken);
    }
  }, [accessToken]);

  // Subscribe to global events — listeners are registered/cleaned by the hook,
  // the underlying socket persists in the module-level singleton
  useSocket(
    '/global/event',
    {
      global_event_update: () => handleOpen(),
    },
    { enabled: !!accessToken }
  );

  return (
    <>
      <BBDialog
        isOpen={showBackdrop}
        title="Tenant Changed"
        size="sm"
        actions={
          <Button
            variant="contained"
            color="secondary"
            onClick={() => window.location.reload()}
          >
            Reload Page
          </Button>
        }
      >
        Your tenant has changed. Please reload the page to continue.
      </BBDialog>
      <QuotaExceededModal />
      {children}
    </>
  );
};

GlobalEventManager.propTypes = {
  children: PropTypes.any,
};

export default GlobalEventManager;
